import { useState } from 'react';
import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  const [imgError, setImgError] = useState(false);

  return (
    <section id="about" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <div className="w-full">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1.5 h-7 rounded-full bg-primary-500" />
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">关于我们</h2>
        </div>

        <div className="flex flex-col md:flex-row gap-8 md:gap-12 rounded-2xl border border-background-200/70 bg-background-50 p-6 md:p-10 lg:p-12">
          <div className="flex-1">
            <h3 className="text-xl md:text-2xl font-bold text-foreground-950 mb-5">
              {aboutData.title}
            </h3>
            {aboutData.desc.split('\n\n').map((paragraph, i) => (
              <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                {paragraph}
              </p>
            ))}

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
              {aboutData.stats.map((stat, i) => (
                <div key={i} className="text-center p-4 rounded-xl bg-background-100">
                  <div className="w-9 h-9 mx-auto rounded-lg bg-primary-50 flex items-center justify-center mb-2">
                    <div className="w-4 h-4 flex items-center justify-center text-primary-500">
                      <i className={`${stat.icon} text-sm`} />
                    </div>
                  </div>
                  <div className="text-xl md:text-2xl font-bold text-primary-600 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full md:w-80 lg:w-96 shrink-0">
            {!imgError ? (
              <div className="rounded-xl overflow-hidden bg-background-100 aspect-[5/4]">
                <img
                  src={aboutData.image}
                  alt="91免费视频网站团队"
                  className="w-full h-full object-cover"
                  onError={() => setImgError(true)}
                />
              </div>
            ) : (
              <div className="rounded-xl bg-background-100 aspect-[5/4] flex items-center justify-center">
                <div className="text-center">
                  <div className="w-16 h-16 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-3">
                    <i className="ri-team-line text-2xl text-primary-500" />
                  </div>
                  <p className="text-sm font-medium text-foreground-500">关于91免费视频网站</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}